import { fabric } from "fabric"
import PathObject from "../objects/path"
import Form from "./base"

export default class ContourForm extends Form {
  protected path() {
    const { contourData } = this.state

    if (contourData) {
      return new PathObject(contourData.path, { ...this.defaultParams, originX: "left", originY: "top" })
    }

    return new PathObject("")
  }

  protected get groupOptions() {
    const { contourData } = this.state

    if (contourData && contourData.scaleX && contourData.scaleY) {
      const { width, height, scaleDiff, scaleX, scaleY } = contourData
      const groupScale = 1 / this.drawables.defaultScale

      return {
        scaleX: (groupScale / scaleDiff) * scaleX,
        scaleY: (groupScale / scaleDiff) * scaleY,
        width,
        height,
        centerPoint: new fabric.Point(width / 2, height / 2),
      }
    }

    return undefined
  }
}
